import { render } from "./DiagnosisBillingList.vue?vue&type=template&id=ba70a202&scoped=true"
import script from "./DiagnosisBillingList.vue?vue&type=script&lang=js"
export * from "./DiagnosisBillingList.vue?vue&type=script&lang=js"

import "./DiagnosisBillingList.vue?vue&type=style&index=0&id=ba70a202&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba70a202"]])

export default __exports__